<template>

  <div class="table-responsive table-card mb-1">
    <table class="table table-nowrap align-middle" id="orderTable">
      <thead class="text-muted table-light">
      <tr class="text-uppercase">
        <th class="sort" data-sort="id">شماره سفارش</th>
        <th class="sort" data-sort="date">تاریخ سفارش</th>
        <th class="sort" data-sort="total">مبلغ سفارش</th>
        <th class="sort" data-sort="income">درآمد</th>
        <th class="sort" data-sort="status">وضعیت</th>
        <th class="sort" data-sort="action">عملیات</th>
      </tr>
      </thead>
      <tbody class="list">
      <tr v-for="(order, index) of skeleton" :key="index">
        <td class="id">
          <Skeletor width="50%" />
        </td>
        <td class="date">
          <Skeletor width="50%" />
        </td>
        <td class="total">
          <Skeletor width="50%" />
        </td>
        <td class="income">
          <Skeletor width="50%" />
        </td>
        <td class="status">
          <Skeletor width="50%" />
        </td>
        <td>
          <Skeletor width="50%" />
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import { Skeletor } from "vue-skeletor";

export default {
  name: "order-list-skeleton",
  data() {
    return {
      skeleton: 10
    }
  },
  components: {
    Skeletor
  }
}
</script>

<style scoped>

</style>

